import React, { useMemo } from 'react';
import Question from 'js/engines/SurveyAssessment/components/Run/Question';
import { useResponseContext } from 'js/engines/CapabilitiesAssessment/ResponseContext';

function Element({ element }) {
  const { responses, participant, respond, unrespond } = useResponseContext();

  const response = responses[element.id];

  const baseResponse = useMemo(() => {
    return response
      ? {
          id: response.id,
          participant_id: participant.id,
        }
      : {
          participant_id: participant.id,
        };
  }, [participant.id, response]);

  const handleQuestionResponse = (questionId, answerId, answerValue) => {
    respond(questionId, {
      ...baseResponse,
      answer_id: answerId,
      value: answerValue,
      is_na: false,
    });
  };

  const handleQuestionUnresponse = (questionId) => {
    unrespond(questionId);
  };

  return (
    <Question
      question={element}
      response={response}
      onRespond={handleQuestionResponse}
      onUnrespond={handleQuestionUnresponse}
    />
  );
}

export default Element;
